import type { ICandidate } from "@bbj-types/candidate";
import { CommunicationTemplateType } from "@bbj-types/communication/enum";
import type { TSendSocialOfferResolver } from "./resolver";

export const typeGuardCommunicationMode = (value: string): CommunicationTemplateType => {
  if (value === CommunicationTemplateType.EMAIL) {
    return CommunicationTemplateType.EMAIL;
  }
  if (value === CommunicationTemplateType.SMS) {
    return CommunicationTemplateType.SMS;
  }
  return CommunicationTemplateType.EMAIL;
};

export const defaultMode = (candidate: ICandidate) => {
  if (candidate.communicationType) {
    return typeGuardCommunicationMode(candidate.communicationType);
  }
  if (candidate.optInEmail) {
    return CommunicationTemplateType.EMAIL;
  }
  if (candidate.optInPhone) {
    return CommunicationTemplateType.SMS;
  }
  return CommunicationTemplateType.EMAIL;
};

export const formatCommunicationData = (candidate: ICandidate, data: TSendSocialOfferResolver) => {
  if (data.mode === CommunicationTemplateType.EMAIL) {
    return {
      emails: data.emails || [
        {
          address: candidate.mail ?? "",
          name: `${candidate.firstName} ${candidate.lastName}`,
        },
      ],
      subject: data.subject || "",
      content: data.content || "",
      cc: data.cc?.map((email) => ({
        address: email,
        name: email,
      })),
    };
  }

  return {
    to: [candidate.phone || ""],
    content: data.content || "",
  };
};
